export const ICON_TEXT_COLOR: string = "#00B107";
